/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactMarkdown from 'react-markdown';
import { Grid } from '@material-ui/core';
import { RenderChatAsLink } from '../../../../MultiBrandChatController/AigoChatWidgetWrapperV2/popOpenChat';

import customBreakpoints from '../../../../../helpers/customBreakpoints';

/* eslint-disable no-shadow */
const styles = (theme) => ({
    morePlants: {
        maxWidth: '1440px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        outlineColor: theme.palette.grey8,
        '& h1': {
            fontSize: '1.25rem',
            fontFamily: 'Hind, sans-serif',
            fontWeight: 700,
            textAlign: 'center',
            color: '#000',
            marginBottom: '0',
            paddingBottom: '20px',
            marginTop: '2rem',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '1.5rem',
                lineHeight: '1.5rem',
                paddingBottom: '0',
                color: '#87AA35',
                fontFamily: 'BebasNeue',
                fontWeight: '500',
                textAlign: 'left',
            },
        },
    },
    contentContainer: {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '2rem',
        padding: '0 15px',
    },
    dividerMatch: {
        paddingBottom: '10px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            display: 'none',
        },
    },
    footerBody: {
        paddingLeft: '15px',
        paddingRight: '15px',
        fontSize: '14px',
        maxWidth: '1270px',
        margin: '0 auto',
        letterSpacing: '.03em',
        WebkitFontSmoothing: 'antialiased',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            textAlign: 'left',
            paddingLeft: '0px !important',
            paddingRight: '0px !important',
        },
        '& h1, h2': {
            width: '100%',
            color: theme.palette.sectionHeaderTextColor,
            fontFamily: theme.typography.fontFamily,
            whiteSpace: 'normal',
        },
        '& h2': {
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: 1.5,
            marginBottom: 0,
            padding: '15px',
            color: '#212121',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '14px',
                lineHeight: '22px',
            },
            '& ul': {
                boxSizing: 'content-box',
            },
        },
        '& p': {
            fontSize: '0.8125rem',
            color: '#212121',
            lineHeight: '1.5',
            margin: '0',
            fontWeight: 400,
            [theme.breakpoints.down(600)]: {
                paddingBottom: '0px !important',
            },
        },
        '& a': {
            color: theme.palette.linkColor,
            fontWeight: 'bold',
            textDecoration: 'underline',
        },
        '& ul': {
            lineHeight: '1.5',
            color: theme.palette.sectionHeaderTextColor,
        },
        '& .MuiGrid-container': {
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                width: 'auto',
                margin: '0',
                '&:last-child': {
                    marginBottom: '25px',
                },
            },
        },
        '& > div': {
            marginTop: '8px !important',
            '& > div': {
                paddingBottom: '0 !important',
                paddingTop: '0 !important',
                [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                    padding: '0px',
                },
                '&.MuiGrid-item': {
                    '& hr': {
                        display: 'none',
                    },
                    '& img': {
                        display: 'none',
                    },
                    [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                        paddingRight: '0',
                        paddingLeft: '0',
                        marginTop: '0',
                        marginBottom: '0',
                        position: 'relative',
                        '& hr': {
                            display: 'block',
                            borderBottom: '1px solid #000',
                            paddingTop: '25px',
                            borderRightWidth: '0',
                            borderTopWidth: '0',
                            borderLeftWidth: '0',
                            width: '90%',
                        },
                        '& img': {
                            display: 'block',
                            height: '55px',
                            width: '55px',
                            backgroundColor: '#F2F2F2',
                            position: 'absolute',
                            left: '43%',
                            top: '83%',
                        },
                    },
                },
            },
        },
    },
    heading: {
        backgroundColor: '#e8eaec',
    },
    body: {
        padding: '0 15px',
        '& p': {
            paddingTop: '10px',
        },
    },
    seoDivider: {
        position: 'relative',
        textAlign: 'center',
        marginTop: '20px',
        marginBottom: '40px',
        [theme.breakpoints.down(600)]: {
            marginBottom: '20px',
        },
        '& hr': {
            backgroundSize: '5px 5px',
            backgroundImage: 'linear-gradient(to right, #000 30%, rgba(255,255,255,0) 0%)',
            borderTop: '1px solid rgba(0,0,0,.1)',
            backgroundRepeat: 'repeat-x',
            backgroundPosition: 'bottom',
            maxWidth: '1400px',
            width: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: '0',
            padding: '0',
            margin: '0 auto',
        },
        '& img': {
            backgroundColor: theme.palette.desktopBgFooter,
            zIndex: '1',
            position: 'relative',
            padding: '0 10px',
            width: '50px',
        },
    },
    footerFaqSection: {
        maxWidth: '1270px',
        margin: '0 auto',
        padding: '0 15px',
        color: '#000',
        [theme.breakpoints.down('1264')]: {
            maxWidth: '960px',
        },
        [theme.breakpoints.down('992')]: {
            maxWidth: '720px',
        },
        [theme.breakpoints.down('768')]: {
            maxWidth: '540px',
        },
        '& p': {
            margin: '0.75rem 0 0',
            fontSize: '1rem',
            fontWeight: 700,
            lineHeight: 1.5,
            paddingBottom: '5px',
        },
        '& .plants-title': {
            backgroundColor: '#e8eaec',
            paddingLeft: '15px',
            paddingTop: '5px',
            fontSize: '20px',
        },
        '& ul': {
            marginTop: 0,
            marginBottom: '1rem',
            '& li': {
                listStyle: 'none',
                fontSize: '0.875rem',
                color: '#2e2c2c',
                '& a': {
                    fontSize: '0.8.125rem',
                    fontWeight: 'bolder',
                    textTransform: 'capitalize',
                    letterSpacing: '0.5px',
                    textDecoration: 'none',
                    color: theme.palette.linkColor,
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
        },
    },
});

const GraphqlSeoFooterV2 = ({ data, classes }) => {
    const { group, title, file } = data;

    if (title === 'FAQs') {
        return (
            <div className={classes.footerFaqSection}>
                <Grid xs={12}>
                    <div>
                        <h1 className="plants-title">{title}</h1>
                    </div>
                </Grid>
                {group?.map((faq) => (
                    <ReactMarkdown
                        source={faq?.copy}
                        renderers={{
                            text: ({ value }) => {
                                if (typeof value === 'string' && value?.toLowerCase()?.includes('chat')) {
                                    return <RenderChatAsLink value={value} />;
                                }
                                return value;
                            },
                        }}
                        skipHtml
                    />
                ))}
            </div>
        );
    }
    return (
        <div className={classes.contentContainer}>
            <div className={classes.seoDivider}>
                <hr />
                {file && <img src={file?.url} alt={file.filename} />}
            </div>
            <div
                className={classes.morePlants}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <div>
                            <h1 className="plants-title">{title}</h1>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div className={classes.footerBody}>
                <Grid container spacing={3} className="grid-container">
                    {group.map((data, i) => (
                        (i < 3)
                        && (
                            <Grid item xs={12} key={data.heading} className={classes.footerBody}>
                                <div>
                                    <div className={classes.heading}>
                                        <ReactMarkdown
                                            source={data.heading}
                                            skipHtml
                                            renderers={{
                                                text: ({ value }) => {
                                                    if (typeof value === 'string' && value?.toLowerCase()?.includes('chat')) {
                                                        return <RenderChatAsLink value={value} />;
                                                    }
                                                    return value;
                                                },
                                            }}
                                        />
                                    </div>
                                    <div className={classes.body}>
                                        <ReactMarkdown
                                            source={data.copy}
                                            skipHtml
                                            renderers={{
                                                text: ({ value }) => {
                                                    if (typeof value === 'string' && value?.toLowerCase()?.includes('chat')) {
                                                        return <RenderChatAsLink value={value} />;
                                                    }
                                                    return value;
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        )
                    ))}
                </Grid>
                <div className={classes.dividerMatch}>
                    {group.map((data, i) => (
                        (data && i === 3) && <div className={classes.seoDivider}> <hr /> </div>
                    ))}
                </div>
                <Grid container spacing={5} justifyContent="center">
                    {group.map((data, i) => (
                        (i >= 3)
                        && (
                            <Grid item xs={12} sm={4} key={data.heading} className={classes.footerBody}>
                                <div>
                                    <ReactMarkdown
                                        source={data.heading}
                                        skipHtml
                                    />
                                    <ReactMarkdown
                                        source={data.copy}
                                        skipHtml
                                    />
                                </div>
                            </Grid>
                        )
                    ))}
                </Grid>
            </div>
        </div>
    );
};

GraphqlSeoFooterV2.propTypes = {
    data: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(GraphqlSeoFooterV2);
